import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import { LocationProvider } from "./contexts/LocationContext";
import { LoadingProvider } from "./contexts/LoadingContext";
import Layout from "./components/layout/Layout";
import FeedPage from "./pages/FeedPage";
import PostDetailPage from "./pages/PostDetailPage";
import CreatePostPage from "./pages/CreatePostPage";
import EditPostPage from "./pages/EditPostPage";
import ActivityPage from "./pages/ActivityPage";
import LeaderboardPage from "./pages/LeaderboardPage";
import ProfilePage from "./pages/ProfilePage";
import RatePage from "./pages/RatePage";
import ChatPage from "./pages/ChatPage";
import ChatsListPage from "./pages/ChatsListPage";
import RankCertificatePage from "./pages/RankCertificatePage";

export default function App() {
  return (
    <AuthProvider>
      <LoadingProvider>
        <LocationProvider>
          <BrowserRouter>
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<FeedPage />} />
              <Route path="/create" element={<CreatePostPage />} />
              <Route path="/chats" element={<ChatsListPage />} />
              <Route path="/posts/:id" element={<PostDetailPage />} />
              <Route path="/posts/:id/edit" element={<EditPostPage />} />
              <Route path="/activity" element={<ActivityPage />} />
              <Route path="/leaderboard" element={<LeaderboardPage />} />
              <Route path="/profile" element={<ProfilePage />} />
              <Route path="/users/:id" element={<ProfilePage />} />
              <Route path="/rate/:responseId" element={<RatePage />} />
              <Route path="/certs/rank/:userId" element={<RankCertificatePage />} />
            </Route>
            <Route path="/chat/:responseId" element={<ChatPage />} />
          </Routes>
          </BrowserRouter>
        </LocationProvider>
      </LoadingProvider>
    </AuthProvider>
  );
}
